import React, { Component } from 'react';
import { Image, Button, Table, Grid, Row, Col, ButtonToolbar } from 'react-bootstrap';

import { strings } from '../strings';
import { InterfaceForm } from './InterfaceForm';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { TitleRow } from '../../../TitleRow';
import { HandleDialog } from '../../../HandleDialog';
import { InterfacesCommand } from '../../commands/InterfacesCommand';
import { TableButton } from '../../../TableButton';
import { HandleMessage } from '../../../HandleMessage';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { SearchBar } from '../../../SearchBar';
import { SearchHelper } from '../../../helpers/SearchHelper';

export class TransportAuthorityInterfaces extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commands: {
                interfaces: new InterfacesCommand(),
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            form: {
                title: undefined,
                data: undefined,
                original: undefined
            },
            actions: {
                isLoading: true,
                isUpdating: false,
                isDeleting: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.getInterfaces();
    }

    // ----------------------

    getInterfaces(resetData = false) {
        if (resetData) {
            const { actions, table } = this.state;

            table.data = [];
            actions.isLoading = true;

            this.setState({
                table: table,
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.interfaces.getAllTransportAuthority(
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ---------------------------

    setErrorMessage(messageReceived) {
        const { message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    setSuccessMessage(messageReceived) {
        const { message } = this.state;
        const updatedMessage = Object.assign({}, message);

        if (message.show) {
            updatedMessage.message = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: updatedMessage
        });
    }

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;
        this.setErrorMessage(messageReceived);

        this.setState({
            table: table,
            actions: actions
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setSuccessMessage(messageReceived);

        this.setState({
            actions: actions
        });

        this.getInterfaces(true);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setErrorMessage(messageReceived);

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    handleCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.data = {
            id: 0,
            url: "",
            namePt: "",
            nameEn: ""
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    handleEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.data = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    handleDeleteClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a interface "${data.namePt}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: data.id
                }
            }
        });
    }

    handleInterfaceSave(data) {
        const { commands, actions } = this.state;
        commands.interfaces.saveTransportAuthority(
            data,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.handleInterfaceFormExit();
    }

    handleInterfaceFormExit() {
        this.setState({
            form: {
                title: undefined,
                data: undefined,
                original: undefined,
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.interfaces.deleteTransportAuthority(
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ---------------------------

    onChangePage(page) {
        const { table } = this.state;

        table.currentPage = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // -------------------

    renderForm() {
        const { form } = this.state;

        if (null === form.data || undefined === form.data) {
            return null;
        }

        const {commands } = this.state;

        return (
            <InterfaceForm title={form.title}
                data={form.data}
                onUploadImage={(a, successCallback) => 
                    commands.interfaces.uploadImageTransportAuthority(
                        a, 
                        successCallback, 
                        (a) => this.operationErrorCallback(a, "isUpdating")
                    )}
                onSave={(a) => this.handleInterfaceSave(a)}
                onHide={() => this.handleInterfaceFormExit()} />
        );
    }

    renderTable(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["namePt", "nameEn"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>{strings.namePt}</th>
                                    <th>{strings.nameEn}</th>
                                    <th>{strings.image}</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partialData.map((data, idx) =>
                                        <tr key={`map-point-${idx}`}>
                                            <td>{data.namePt}</td>
                                            <td>{data.nameEn}</td>
                                            <td><Image src={data.url} thumbnail style={{ maxWidth: 100, maxHeight: 100 }} /></td>
                                            <td>
                                                <ButtonToolbar className="pull-right">
                                                    <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(data)} />
                                                    <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(data)} />
                                                </ButtonToolbar>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={activePage}
                            elementsPerPage={table.elementsPerPage}
                            dataLength={dataFiltered.length}
                            onChangePage={(a) => this.onChangePage(a)}
                            onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;
        const { title } = this.props;

        return (
            <div>
                <TitleRow title={title} showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.handleCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isUpdating || actions.isDeleting)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}